import { Button } from '@flatfile/baseline'
import { Link } from 'react-router-dom'

export const DefaultActions = () => {
  return (
    <Link to='/upload'>
      <Button variant='outline'>Upload file</Button>
    </Link>
  )
}
